import React, { useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import ShareIcon from "@mui/icons-material/Share";
import PlaceIcon from "@mui/icons-material/Place";
import Experience from "pages/user/setting/components/Experience";
import Education from "pages/user/setting/components/Education";
import Certification from "pages/user/setting/components/Certification";
import Skills from "pages/user/setting/components/Skills";
import Bio from "pages/user/setting/components/Bio";
import { useReactToPrint } from "react-to-print";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import {
  // Button,
  CircularProgress,
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/joy";
import Button from "@mui/material/Button";
import {
  ConnectWithoutContact,
  Facebook,
  FiberManualRecordRounded,
  FiberManualRecordTwoTone,
  GitHub,
  HourglassTopTwoTone,
  Instagram,
  LinkTwoTone,
  LinkedIn,
  MailTwoTone,
  Menu,
  PersonAddAltRounded,
  RocketLaunchTwoTone,
  SmsFailedRounded,
  Star,
  StarRounded,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import {
  School as SchoolIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import { useState } from "react";
import { useNavigate, useParams, useOutletContext } from "react-router";
import { Popup } from "layout/Popup";
import { useGlobalContext } from "global/context";
import { useEffect } from "react";
import moment from "moment";
import { toast } from "react-hot-toast";
import ProfileDetails from "./components/ProfileDetails";
import ProfileAnswers from "./components/ProfileAnswers";
import ProfileQuestions from "./components/ProfileQuestions";
import ProfileConnections from "./components/ProfileConnections";
import SuggestedExperts from "pages/user/widgets/SuggestedExperts";
import TrendingQuestions from "pages/user/widgets/TrendingQuestions";
import { Rating } from "@mui/material";
import ResumeMaker from "./components/Resume/ResumeMaker";
import { Link, useLocation } from "react-router-dom";
import GyaniRating from "../Home/components/GyaniRating";
import useDidMountEffect from 'global/useDidMountEffect'

const labels = {
  0.0: "Biginner",
  0.1: "Biginner",
  0.2: "Biginner",
  0.3: "Biginner",
  0.4: "Biginner",
  0.5: "Just Started",
  0.6: "Just Started",
  0.7: "Just Started",
  0.8: "Just Started",
  0.9: "Just Started",
  1.0: "Just Started+",
  1.1: "Just Started+",
  1.2: "Just Started+",
  1.3: "Just Started+",
  1.4: "Just Started+",
  1.5: "Still Learning",
  1.6: "Still Learning",
  1.7: "Still Learning",
  1.8: "Still Learning",
  1.9: "Still Learning",
  2.0: "Still Learning+",
  2.1: "Still Learning+",
  2.2: "Still Learning+",
  2.3: "Still Learning+",
  2.4: "Still Learning+",
  2.5: "Gaining Expertise",
  2.6: "Gaining Expertise",
  2.7: "Gaining Expertise",
  2.8: "Gaining Expertise",
  2.9: "Gaining Expertise",
  3: "Gaining Expertise+",
  3.0: "Gaining Expertise+",
  3.1: "Gaining Expertise+",
  3.2: "Gaining Expertise+",
  3.3: "Gaining Expertise+",
  3.4: "Gaining Expertise+",
  3.5: "Expert Now",
  3.6: "Expert Now",
  3.7: "Expert Now",
  3.8: "Expert Now",
  3.9: "Expert Now",
  4: "Expert Now+",
  4.0: "Expert Now+",
  4.1: "Expert Now+",
  4.2: "Expert Now+",
  4.3: "Expert Now+",
  4.4: "Expert Now+",
  4.5: "Param Gyani",
  4.6: "Param Gyani",
  4.7: "Param Gyani",
  4.8: "Param Gyani",
  4.9: "Param Gyani",
  5: "Param Gyani+",
  5.0: "Param Gyani+",
};

function UserProfile({ data }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ComponentPdf = useRef();
  const {
    socket,
    setSocket,
    userData,
    token,
    api,
    users,
    apiAuth,
    setShowMessage,
    setMessageTo,
    setAuth,
    onlineUsers,
    setOnlineUsers,
  } = useGlobalContext();
  const [setSkills] = useOutletContext();
  const navigate = useNavigate();
  const locate = useLocation();
  const [profile, setProfile] = useState(data);
  const [showResume, setshowResume] = useState(false);
  const { username } = useParams();
  const [isOnline, setIsOnline] = useState(false);
  const [loading, setLoading] = useState(true);
  const [componentType, setComponentType] = useState("details");
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [lastActive, setLastActive] = useState();
  const location = useLocation();
  const [showGyaniModal, setShowGyaniModal] = React.useState(false);
  const [suggestedExperts, setSuggestedExperts] = useState([]);
  const [showContactDetails, setShowContactDetails] = useState(false);

  // console.log("Profile: ",profile)
  // console.log("userData: ",userData)
  // console.log("Online users : ", onlineUsers)
  const isOwner = userData?.id === profile?.id;
  useEffect(() => {
    // Check if the modal should be opened based on the navigation state
    if (location.state && location.state.openGyaniModal) {
      setShowGyaniModal(true);
    }
  }, [location.state]);

  const toggleGyaniModal = () => {
    setShowGyaniModal(prev => !prev);
  };

  useEffect(() => {
    if (socket) {
      // Listen for USER_ADDED event
      socket.on("USER_ADDED", (updatedOnlineUsers) => {
        // console.log("Updated list of online users:", updatedOnlineUsers);
        setOnlineUsers(updatedOnlineUsers); // Update state with the new list of online users
      });

      // Clean up the event listener on unmount
      // return () => {
      //   socket.off("USER_ADDED");
      // };
    }
  }, [socket, setOnlineUsers]);

  const getSuggestedExperts = async () => {

    try {
      const res = await api.get(`/app/user/rateGyani?userId=${userData?.id}`);
      if (res?.status === 200) {
        // console.log('My Connections : ', res);
        setSuggestedExperts(res?.data?.results);

        if (!res.data.results || res.data.results.length === 0) {
          setShowGyaniModal(false);
        }
      }
    } catch (e) {
      console.log(e);
      Popup("error", e?.response?.data?.message);
    }
  };

  useDidMountEffect(() => {
    // console.log({ locality, subLocality });
    getSuggestedExperts();
  }, []);

  useEffect(() => {
    getSuggestedExperts();
  }, []);
  const getProfile = async () => {
    let profileNotify = toast.loading("Getting profile information...");
    setLoading(true);
    try {
      if (username && username === "profile") {
        const res = await api.get(
          `app/user/profile/${userData?.id}?userId=${userData?.id}`
        );
        if (res.status == 200) {
          toast.dismiss(profileNotify);
          toast.success("Information fetched successfully");
          setProfile(res?.data);
          setSkills(res?.data?.skills);
          setLoading(false);
          setLastActive(res?.data.last_active);
          // localStorage.setItem('user', user);
          // console.log(res);
          console.log("Profile: ", res?.data);
          // console.log("Profile LastActive: ", res?.data.last_active);
        }
      } else if (username) {
        const res = await api.get(
          `app/user/profile/${username || userData?.id}?userId=${userData?.id}`
        );
        if (res.status == 200) {
          toast.dismiss(profileNotify);
          toast.success("Information fetched successfully");
          setProfile(res?.data);
          setSkills(res?.data?.skills);
          setLoading(false);
          setLastActive(res?.data.last_active);
          // localStorage.setItem('user', user);
          // console.log(res);
          console.log("Profile: ", res?.data);
        }
      } else if (userData?.id) {
        const userId = locate.state?.id || userData?.id;
        if (!userId) {
          throw new Error("User ID is missing");
        }
        const res = await api.get(`/app/user/${userId}`);
        if (res.status == 200) {
          toast.dismiss(profileNotify);
          toast.success("Information fetched successfully");
          setProfile(res?.data);
          setSkills(res?.data?.skills);
          setLoading(false);
          setLastActive(res?.data.last_active);
          // localStorage.setItem('user', user);
        }
      } else {
        // toast.dismiss(profileNotify);
        toast.error(
          "Error getting profile information, Please try again later!"
        );
        navigate("/404");
      }
    } catch (error) {
      toast.dismiss(profileNotify);
      if (error?.response?.data?.status === 404) {
        toast.error(
          "Error getting profile information, Please try again later!"
        );
        navigate("/404");
      } else {
        // toast.error(error?.response?.data?.message);
        // toast("Redirecting back to last visited page...");
        // navigate(-1);
        toast.error(
          "Error getting profile information, Please try again later!"
        );
        navigate("/404");
      }
      if (data?.id) {
      }
      // setLoading(false);
    }
  };
  const handleConnect = async () => {
    try {
      const res = await api.post(`/app/connections/send-request`, {
        senderId: userData?.id,
        receiverId: profile?.id,
      });
      if (res?.status === 200) {
        setProfile((user) => {
          return { ...user, connectionStatus: "pending" };
        });
        toast.success(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        setAuth(true);
      } else {
        toast.error(error?.response?.data?.message);
      }
    }
  };
  const getProfileCompletion = async () => {
    try {
      const res = await api.get(`/app/user/profile-completion/${userData?.id}`);
      if (res?.status === 200) {
        // console.log("Profile completion:  ", res?.data);
        setProfileCompletion(res?.data?.completionPercentage);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleMessage = () => {
    setShowMessage(true);
    setMessageTo(profile);
  };

  useEffect(() => {
    getProfileCompletion();
  }, [profile?.id, data?.id, userData?.id]);

  useEffect(() => {
    setIsOnline(false);
    getProfile();
    window.scrollTo(0, 0);
  }, [username]);

  useEffect(() => {
    let isLive = onlineUsers.find(
      (online) => isOnline?.username === profile?.id
    );
    // console.log("Current User Status: ", isLive);
    // console.log("Current User ID: ", isLive?.username);

    if (isLive?.username === profile?.id) {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  }, [onlineUsers]);

  const ProfileSubComponents = () => {
    switch (componentType) {
      case "details":
        return <ProfileDetails profile={profile} />;
      case "questions":
        return <ProfileQuestions profile={profile} />;
      case "answers":
        return <ProfileAnswers profile={profile} />;
      case "connections":
        return <ProfileConnections profile={profile} />;
      default:
        return <ProfileDetails profile={profile} />;
    }
  };

  const pdf = useReactToPrint({
    content: () => ComponentPdf.current,
  });
  const genratePDF = () => {
    setshowResume(true);
    return setTimeout(() => {
      pdf();
      setshowResume(false);
    }, 100);
  };

  const [hideProfileDiv, setHideProfileDiv] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setHideProfileDiv(true);
      } else {
        setHideProfileDiv(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Fetch the contact visibility setting for the logged-in user
    if (isOwner) {
      setShowContactDetails(profile?.show_contact_details);
    }
  }, [profile, isOwner]);



  // console.log("Online : ", profile);

  return (
    <>
      <div
        className=""
        style={{
          width: "100%",
          ...(!isMobile && {
            maxHeight: "85vh",
            overflowY: "scroll",
            justifyContent: "flex-end",
          }),
        }}
      >
        <div className="rounded-4 shadow mb-4 pb-4">
          <div className="col ">
            <div
              className="row justify-content-end align-items-end flex-column flex-wrap h-[7vh] md:h-[20vh]"
              style={{
                backgroundImage: "linear-gradient(45deg, #3f00ff52, #5836dd)",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
              }}
            >
              {/* <h1
                className="fw-bold fs-100 pr-4"
                style={{ color: "#ffffff12" }}
              >
                {labels[Math.round(profile?.rating) || 0.5]}
              </h1> */}
              {hideProfileDiv ? null : (
                <div className="p-3 pr-4 d-flex align-items-center ">
                  <span className="text-white fs-18 fw-bold">
                    {profile?.rating || 0} &nbsp;
                  </span>
                  <Rating
                    name="text-feedback"
                    value={Number(profile?.rating) || 0} // Convert to number
                    readOnly={
                      profile?.id === userData?.id || userData?.id === undefined
                        ? true
                        : false
                    }
                    precision={0.5}
                    icon={<StarRounded fontSize="inherit" />}
                    emptyIcon={
                      <StarRounded
                        style={{ opacity: 0.55 }}
                        fontSize="inherit"
                      />
                    }
                  />
                </div>
              )}
            </div>
            <div className="d-flex flex-wrap justify-content-between align-items-end">
              <Avatar
                alt="Remy Sharp"
                src={profile?.avatar_url}
                style={
                  isMobile
                    ? {
                      marginTop: "-70px",
                      marginLeft: "5px",
                      border: "5px solid white",
                    }
                    : {
                      marginTop: "-100px",
                      marginLeft: "30px",
                      border: "5px solid white",
                    }
                }
                sx={
                  isMobile
                    ? { width: 100, height: 100 }
                    : { width: 150, height: 150 }
                }
              />
              <div className="">
                <Stack spacing={2} direction="row">
                  {/* <Button variant='soft'>Hire</Button>
                              <Button variant='soft'>Setting</Button>
                              <Button variant='soft'>Public</Button> */}
                  {/* <IconButton variant='plain'>
                                <Menu />
                              </IconButton> */}
                  {profile?.id === userData?.id && (
                    <div className="hero-btn-box flex flex-wrap justify-end items-center py-3 md:py-8 space-x-4">
                      <Button
                        variant="contained" // Solid background for distinction
                        sx={{
                          backgroundColor: "#B5FF88", // Distinct blue color
                          color: "#266400", // White text
                          "&:hover": {
                            backgroundColor: "#7EFF04", // Darker blue on hover
                          },
                          fontWeight: "bold",
                          fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.875rem" }, // Responsive text sizes
                          px: { xs: 0.8, sm: 1, md: 1.5 }, // Responsive padding-x
                          py: { xs: 0.5, sm: 0.6, md: 0.8 }, // Responsive padding-y
                          display: "flex",
                          alignItems: "center",
                          textTransform: "capitalize", // Adjust text case
                          borderRadius: "8px", // Rounded corners for modern feel
                        }}
                      >
                        <Link
                          to="/resume-maker"
                          state={profile}
                          style={{
                            color: "#266400", // Ensure white text inside the button
                            textDecoration: "none", // Remove underline
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <i className="bi bi-filetype-pdf" style={{ marginRight: "0.3rem" }} /> Resume
                        </Link>
                      </Button>
                      <Button
                        onClick={() => navigate("/setting/profile")}
                        variant="contained"
                        sx={{
                          backgroundColor: "#ffd6d6 ", // Custom success green
                          color: "#640500 ", // Text color
                          "&:hover": {
                            backgroundColor: "#ffa9a5 ", // Darker green on hover
                          },
                          letterSpacing: "1.5px",
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                          height: "fit-content",
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.875rem" },
                          px: { xs: 0.8, sm: 1, md: 1.5 }, // Padding X-axis
                          py: { xs: 0.5, sm: 0.7, md: 0.8 }, // Padding Y-axis
                          borderRadius: "8px", // Optional rounded corners
                        }}
                      >
                        <i className="la la-gear" style={{ marginRight: "0.3rem" }} /> Settings
                      </Button>
                    </div>
                  )}

                </Stack>
              </div>
            </div>
            <div className="p-1 md:p-5">
              <div className="media-body mb-3">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: isMobile ? "flex-start" : "center",
                    justifyContent: "space-between",
                    padding: "1rem",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  {/* Name and Profession */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: isMobile ? "wrap" : "nowrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: isMobile ? "100%" : "auto",
                      marginBottom: isMobile ? "1rem" : "0",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        marginRight: isMobile ? "0.5rem" : "1rem",
                        marginBottom: isMobile ? "0.5rem" : "0",
                      }}
                    >
                      {userData?.first_name} {userData?.last_name}
                    </h3>
                    <Button
                      onClick={() => { }}
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#ffd6d6 ", // Custom success green
                        color: "#640500 ", // Text color
                        "&:hover": {
                          backgroundColor: "#ffa9a5 ", // Darker green on hover
                        },
                        letterSpacing: "1.2px",
                        display: "flex",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        height: "fit-content",
                        textTransform: "capitalize",
                        fontWeight: "bold",
                        fontSize: { xs: "0.6rem", sm: "0.60rem", md: "0.70rem" },
                        px: { xs: 0.8, sm: 0.8, md: 1 }, // Padding X-axis
                        py: { xs: 0.5, sm: 0.6, md: 0.7 }, // Padding Y-axis
                        borderRadius: "8px", // Optional rounded corners
                      }}
                    >
                      {profile?.profile?.profession || profile?.profile?.role}
                    </Button>
                  </div>

                  {/* Location */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: isMobile ? "flex-start" : "flex-end",
                      width: isMobile ? "100%" : "auto",
                    }}
                  >
                    <Link to={`/profile/nearby/${profile?.profile?.location}`}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#955cbd ", // Custom success green
                          color: "#ffffff", // Text color
                          "&:hover": {
                            backgroundColor: "#b481d6", // Darker green on hover
                          },
                          letterSpacing: "1.5px",
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                          height: "fit-content",
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          fontSize: { xs: "0.80rem", sm: "0.75rem", md: "0.875rem" },
                          px: { xs: 0.7, sm: 1, md: 1.5 }, // Padding X-axis
                          py: { xs: 0.4, sm: 0.6, md: 0.8 }, // Padding Y-axis
                          borderRadius: "8px", // Optional rounded corners
                        }}
                      >
                        {profile?.profile?.role === "student" ? (
                          <>
                            <PersonIcon style={{ marginRight: "0.5rem" }} />
                            Nearby Teachers
                          </>
                        ) : (
                          <>
                            <SchoolIcon style={{ marginRight: "0.5rem" }} />
                            Nearby Institutes
                          </>
                        )}
                      </Button>
                    </Link>
                  </div>
                </div>
                {isOnline ? (
                  <span className="text-success fw-bold">
                    <FiberManualRecordRounded
                      color="success"
                      sx={{ fontSize: "14px", marginRight: "10px" }}
                    />
                    Online
                  </span>
                ) : (
                  <span>
                    <FiberManualRecordTwoTone
                      color=""
                      sx={{ fontSize: "14px", marginRight: "10px" }}
                    />
                    Last active {moment(profile?.profile?.createdAt).calendar()}
                  </span>
                )}
                <p>
                  <i className="bi bi-map-fill mr-2 text-info"></i>
                  {profile?.profile?.location
                    ? profile?.profile?.location + ", "
                    : profile?.profile?.address?.city &&
                    profile?.profile?.address?.city + ", "}
                  India
                </p>
                <div className="contact-details">
                  {/* <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center mb-3 space-y-2 md:space-y-0">
                    <div>
                      <div className="flex items-center space-x-2">
                        <span className="font-bold text-purple-900">Mobile:</span>
                        <span className="text-purple-900">{profile?.profile?.phone}</span>
                        {isMobile && (
                          <Button
                            // onClick={toggleContactDetails}
                            variant="contained"
                            sx={{
                              backgroundColor: "#ffd6d6 ", // Custom success green
                              color: "#640500 ", // Text color
                              "&:hover": {
                                backgroundColor: "#ffa9a5 ", // Darker green on hover
                              },
                              letterSpacing: "1.5px",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                              height: "fit-content",
                              textTransform: "capitalize",
                              fontWeight: "bold",
                              fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.875rem" },
                              px: { xs: 1, sm: 1, md: 1.5 }, // Padding X-axis
                              py: { xs: 0.5, sm: 0.6, md: 0.8 }, // Padding Y-axis
                              borderRadius: "8px", // Optional rounded corners
                            }}
                          >
                            {showContactDetails ? "Hide Contact Details" : "Show Contact Details"}
                          </Button>
                        )}
                      </div>
                      <div>
                        <span className="font-bold text-purple-900">Email:</span>
                        <span className="text-purple-900">{profile?.email}</span>
                      </div>
                    </div>
                  </div> */}

                </div>
                {profile?.presentWork ? (
                  <>
                    <li className="meta-privacy d-inline-block fw-bold mr-2">
                      <FiberManualRecordTwoTone
                        color="secondary"
                        sx={{
                          fontSize: "10px",
                          marginRight: "10px",
                        }}
                      />
                      {profile?.presentWork?.title}{" "}
                      {profile?.presentWork?.subject &&
                        `(${profile?.presentWork?.subject})`}{" "}
                      at {profile?.presentWork?.organization}
                    </li>
                    <li className="meta-privacy d-inline-block mr-2">
                      <FiberManualRecordTwoTone
                        color="secondary"
                        sx={{ fontSize: "10px", marginRight: "10px" }}
                      />
                      <span className="text-capitalize">
                        {profile?.presentWork?.employment_type?.replace(
                          "-",
                          " "
                        )}
                      </span>
                    </li>
                  </>
                ) : null}

                {profile?.presentWork ? (
                  <ul>
                    <li className="meta-privacy d-inline-block  mr-2">
                      <span className="fw-bold text-info">Job Location:</span>{" "}
                      {profile?.presentWork?.location}
                    </li>
                    {/* <li className="meta-privacy d-inline-block fw-bold mr-2"><FiberManualRecordTwoTone color='secondary' sx={{ fontSize: '10px', marginRight: '10px' }} /> Lead Engineer at Govardhan Learning Cloud</li>
                                  <li className="meta-privacy d-inline-block mr-2"><FiberManualRecordTwoTone color='secondary' sx={{ fontSize: '10px', marginRight: '10px' }} /> Full Time</li> */}
                  </ul>
                ) : null}
                {/* <p><span className='fw-semibold'>Talks about:</span> #english, #mathematics, #india, #g20</p> */}
                <div className="">
                  {profile?.profile?.social_links?.facebook ? (
                    <Tooltip title={profile?.profile?.social_links?.facebook}>
                      <IconButton
                        href={profile?.profile?.social_links?.facebook}
                        target="_blank"
                        className="mr-1 bg-light  rounded text-primary"
                      >
                        <Facebook sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}

                  {profile?.profile?.social_links?.instagram ? (
                    <Tooltip title={profile?.profile?.social_links?.instagram}>
                      <IconButton
                        href={profile?.profile?.social_links?.instagram}
                        target="_blank"
                        className="mr-1 bg-light  text-danger rounded"
                      >
                        <Instagram sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {profile?.profile?.social_links?.linkedin ? (
                    <Tooltip title={profile?.profile?.social_links?.linkedin}>
                      <IconButton
                        href={profile?.profile?.social_links?.linkedin}
                        target="_blank"
                        className="mr-1 bg-light  rounded text-primary"
                      >
                        <LinkedIn sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {profile?.profile?.social_links?.twitter ? (
                    <Tooltip title={profile?.profile?.social_links?.twitter}>
                      <IconButton
                        href={profile?.profile?.social_links?.twitter}
                        target="_blank"
                        className="mr-1 bg-light  text-info rounded"
                      >
                        <Twitter sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {profile?.profile?.social_links?.youtube ? (
                    <Tooltip title={profile?.profile?.social_links?.youtube}>
                      <IconButton
                        href={profile?.profile?.social_links?.youtube}
                        target="_blank"
                        className="mr-1 bg-light  text-danger rounded"
                      >
                        <YouTube sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}

                  {profile?.profile?.social_links?.github ? (
                    <Tooltip title={profile?.profile?.social_links?.github}>
                      <IconButton
                        href={profile?.profile?.social_links?.github}
                        target="_blank"
                        className="mr-1 bg-light  text-dark rounded"
                      >
                        <GitHub sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {profile?.profile?.social_links?.website ? (
                    <Tooltip title={profile?.profile?.social_links?.website}>
                      <IconButton
                        href={profile?.profile?.social_links?.website}
                        target="_blank"
                        className="mr-1 bg-light  text-dark rounded"
                      >
                        <LinkTwoTone sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </div>
              </div>

              <Stack direction="row" spacing={2}>
                {/* <Button variant='outlined' color='info' onClick={() => navigate('/messages', { state: { userId: profile?.id } })}>Message</Button> */}
                {profile?.id !== userData?.id ? (
                  <Button
                    color={
                      profile?.connectionStatus === "accepted"
                        ? "success"  // Green for accepted
                        : profile?.connectionStatus === "pending"
                          ? "warning"  // Yellow for pending
                          : profile?.connectionStatus === "rejected"
                            ? "error"    // Red for rejected
                            : "primary"  // Blue for default
                    }
                    variant="contained"
                    size="sm"
                    startDecorator={
                      profile?.connectionStatus === "accepted" ? (
                        <MailTwoTone />
                      ) : profile?.connectionStatus === "pending" ? (
                        <HourglassTopTwoTone />
                      ) : profile?.connectionStatus === "rejected" ? (
                        <SmsFailedRounded />
                      ) : (
                        <PersonAddAltRounded />
                      )
                    }
                    className="rounded-2"
                    sx={{
                      letterSpacing: "1.5px",
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                      px: { xs: 1, sm: 2, md: 3 }, // Responsive padding (X-axis)
                      py: { xs: 0.5, sm: 1, md: 1.5 }, // Responsive padding (Y-axis)
                      borderRadius: "8px", // Rounded corners
                      "&:hover": {
                        backgroundColor: (theme) => theme.palette[profile?.connectionStatus === "accepted" ? "success" : profile?.connectionStatus === "pending" ? "warning" : profile?.connectionStatus === "rejected" ? "error" : "primary"].dark,
                      }
                    }}
                    onClick={
                      profile?.connectionStatus === "accepted"
                        ? handleMessage
                        : profile?.connectionStatus === "pending"
                          ? null
                          : handleConnect
                    }
                  >
                    {profile?.connectionStatus === "accepted"
                      ? "Message"
                      : profile?.connectionStatus === "pending"
                        ? "Requested"
                        : profile?.connectionStatus === "rejected"
                          ? "Declined"
                          : "Connect"}
                  </Button>

                ) : null}
                {/* {profile?.role === "institute" ? (
                  <Button variant="soft" color="success">
                    Hire Me
                  </Button>
                ) : null} */}
                <Button
                  onClick={() =>
                    window.open(
                      `https://wa.me/?text=https://www.eksathi.com/${profile?.username}`,
                      "rel=noopener noreferrer"
                    )
                  }
                  variant="contained"
                  sx={{
                    backgroundColor: "#cfe8ff", // Custom light blue
                    color: "#004080", // Text color - darker blue
                    "&:hover": {
                      backgroundColor: "#99d1ff", // Darker blue on hover
                    },
                    letterSpacing: "1.5px", // Consistent letter spacing
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    height: "fit-content",
                    textTransform: "capitalize", // Text case adjustment
                    fontWeight: "bold", // Bold text
                    fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.875rem" }, // Responsive font sizes
                    px: { xs: 1, sm: 1, md: 1.5 }, // Responsive padding (X-axis)
                    py: { xs: 0.4, sm: 0.6, md: 0.8 }, // Responsive padding (Y-axis)
                    borderRadius: "8px", // Rounded corners
                  }}
                >
                  Share Profile
                  <ShareIcon
                    style={{
                      marginLeft: "0.5rem",
                      fontSize: isMobile ? "1rem" : "1.5rem",
                    }}
                  />
                </Button>

                <Button
                  onClick={() => navigate("/careersparent/employee/dashboard")}
                  variant="contained"
                  sx={{
                    backgroundColor: "#ffe3b3", // Custom light orange
                    color: "#7a4500", // Text color - dark orange
                    "&:hover": {
                      backgroundColor: "#ffc077", // Darker orange on hover
                    },
                    letterSpacing: "1.5px", // Consistent letter spacing
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    height: "fit-content",
                    textTransform: "capitalize", // Text case adjustment
                    fontWeight: "bold", // Bold text
                    fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.875rem" }, // Responsive font sizes
                    px: { xs: 1, sm: 1, md: 1.5 }, // Responsive padding (X-axis)
                    py: { xs: 0.4, sm: 0.6, md: 0.8 }, // Responsive padding (Y-axis)
                    borderRadius: "8px", // Rounded corners
                  }}

                >
                  <i className="bi bi-database-dash" style={{ marginRight: "0.5rem" }}></i>
                  Career Dashboard
                </Button>

              </Stack>
            </div>
          </div>
        </div>

        {isMobile ? (
          <div
            className="flex overflow-x-auto space-x-1" // Updated to use Tailwind flex utilities
            style={{
              flexWrap: "nowrap", // Prevent wrapping
            }}
          >
            <div
              className="flex-shrink-0 w-[22%] m-1"
            >
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{
                  cursor: "pointer",
                  display: "flex", // Enable flexbox layout
                  flexDirection: "column", // Stack items vertically
                  justifyContent: "center", // Center items vertically
                  alignItems: "center", // Center items horizontally
                  textAlign: "center", // Center text inside media-body
                  padding: "10px", // Add padding if needed for spacing
                }}
                onClick={() => setComponentType("details")}
              >
                <CircularProgress
                  size="lg" // Adjusted size of the CircularProgress
                  className="mb-3" // Adjusted margin to separate from text
                  determinate
                  value={Math.round(profileCompletion)}
                  style={{ margin: "auto" }} // Center progress bar
                >
                  <Avatar
                    alt={profile?.user?.name}
                    src={profile?.user?.avatar_url}
                    sx={{ width: 30, height: 30 }} // Adjusted size of the Avatar
                  />
                </CircularProgress>
                {profile?.user?.id !== userData?.id ? (
                  <div className="media-body" style={{ textAlign: "center" }}>
                    <p
                      className="fs-15"
                      style={{
                        color: "rgb(18 81 199)",
                        margin: 0, // Removed default margins
                        padding: 0, // Removed padding if any
                      }}
                    >
                      View Profile
                    </p>
                  </div>
                ) : (
                  <div className="media-body" style={{ textAlign: "center" }}>
                    <h5
                      className="fw-bold fs-40"
                      style={{ color: "rgb(18 81 199)", margin: "0" }}
                    >
                      {Math.round(profileCompletion)}%
                    </h5>
                    <p
                      className="fs-15"
                      style={{
                        color: "rgb(18 81 199)",
                        margin: 0, // Removed default margins
                        padding: 0, // Removed padding if any
                      }}
                    >
                      Completed
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div
              className="flex-shrink-0 w-[22%] m-1"
            >
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{
                  cursor: "pointer",
                  display: "flex", // Center content horizontally
                  justifyContent: "center",
                }}
                onClick={() => setComponentType("questions")}
              >
                <div className="media-body" style={{ textAlign: "center" }}>
                  <div
                    className="icon-element icon-element- mr-4 bg-1"
                    style={{
                      marginLeft: "17px",
                      width: "30px", // Adjust width of the container
                      height: "30px", // Adjust height of the container
                      display: "flex", // Use flexbox for centering
                      justifyContent: "center", // Center content horizontally
                      alignItems: "center", // Center content vertically
                    }}
                  >
                    <p
                      className="fw-bold"
                      style={{
                        fontSize: "18px", // Reduced font size
                        color: "white", // Ensure text color is white
                        margin: 0, // Remove default margins
                      }}
                    >
                      Q
                    </p>
                  </div>
                  <h5 className="fw-bold fs-40" style={{ color: "#28d5a7" }}>
                    {profile?.stats?.questionCount}
                  </h5>
                  <p
                    className="fs-15"
                    style={{
                      color: "rgb(18 81 199)",
                      margin: 0, // Removed default margins
                      padding: 0, // Removed padding if any
                    }}
                  >
                    Questions
                  </p>
                </div>
              </div>
            </div>
            <div
              className="flex-shrink-0 w-[22%] m-1"
            >
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{
                  cursor: "pointer",
                  display: "flex", // Center content horizontally
                  justifyContent: "center",
                }}
                onClick={() => setComponentType("answers")}
              >
                <div className="media-body" style={{ textAlign: "center" }}>
                  <div
                    className="icon-element icon-element- mr-4 bg-1"
                    style={{
                      marginLeft: "17px",
                      width: "30px", // Adjust width of the container
                      height: "30px", // Adjust height of the container
                      display: "flex", // Use flexbox for centering
                      justifyContent: "center", // Center content horizontally
                      alignItems: "center", // Center content vertically
                    }}
                  >
                    <p
                      className="fw-bold"
                      style={{
                        fontSize: "18px", // Reduced font size
                        color: "white", // Ensure text color is white
                        margin: 0, // Remove default margins
                      }}
                    >
                      A
                    </p>
                  </div>

                  <h5 className="fw-bold fs-40" style={{ color: "#8747ff" }}>
                    {profile?.stats?.answerCount}
                  </h5>
                  <p
                    className="fs-15"
                    style={{
                      color: "rgb(18 81 199)",
                      margin: 0, // Removed default margins
                      padding: 0, // Removed padding if any
                    }}
                  >
                    Answers
                  </p>
                </div>
              </div>
            </div>

            <div
              className="flex-shrink-0 w-[22%] m-1"
            >
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                }} // Center content horizontally
                onClick={() => setComponentType("connections")}
              >
                <div className="media-body" style={{ textAlign: "center" }}>
                  <div
                    className="icon-element icon-element- mr-4 bg-1"
                    style={{
                      marginLeft: "22px",
                      width: "30px", // Adjust width of the container
                      height: "30px", // Adjust height of the container
                      display: "flex", // Use flexbox for centering
                      justifyContent: "center", // Center content horizontally
                      alignItems: "center", // Center content vertically
                    }}
                  >
                    <p
                      className="fw-bold"
                      style={{
                        fontSize: "18px", // Reduced font size
                        color: "white", // Ensure text color is white
                        margin: 0, // Remove default margins
                      }}
                    >
                      C
                    </p>
                  </div>
                  <h5 className="fw-bold fs-40 text-warning">
                    {profile?.stats?.connectionCount}
                  </h5>
                  <p
                    className="fs-15"
                    style={{
                      color: "rgb(18 81 199)",
                      margin: 0, // Removed default margins
                      padding: 0, // Removed padding if any
                    }}
                  >
                    Connections
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between flex-wrap">
            <div className="responsive-column-half  ">
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{ cursor: "pointer" }}
                onClick={() => setComponentType("details")}
              >
                {/* <div className="icon-element icon-element- bg-info">
                      <p className='fw-bold fs-30 text-white'>P</p>
                    </div> */}
                <CircularProgress
                  size="lg"
                  className=" mr-3"
                  determinate
                  value={Math.round(profileCompletion)}
                >
                  <Avatar
                    alt={profile?.user?.name}
                    src={profile?.user?.avatar_url}
                    sx={{ width: 50, height: 50 }}
                  />
                </CircularProgress>
                {profile?.user?.id !== userData?.id ? (
                  <div className="media-body">
                    <h5
                      className="fw-bold fs-27"
                      style={{ color: "rgb(18 81 199)", minHeight: 78 }}
                    >
                      View <br /> Profile
                    </h5>

                    {/* <p className="fs-20">Profile</p> */}
                  </div>
                ) : (
                  <div className="media-body">
                    <h5
                      className="fw-bold fs-40"
                      style={{ color: "rgb(18 81 199)" }}
                    >
                      {Math.round(profileCompletion)}%
                    </h5>
                    <p className="fs-15">Completed</p>
                  </div>
                )}
              </div>
            </div>

            <div className="responsive-column-half ">
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow "
                style={{ cursor: "pointer" }}
                onClick={() => setComponentType("questions")}
              >
                <div className="icon-element icon-element- mr-4 bg-2">
                  <p className="fw-bold fs-30 text-white">Q</p>
                </div>
                <div className="media-body">
                  <h5 className="fw-bold fs-40" style={{ color: "#28d5a7" }}>
                    {profile?.stats?.questionCount}
                  </h5>
                  <p className="fs-15">Questions</p>
                </div>
              </div>
            </div>
            {/* end col-lg-4 */}
            <div className="responsive-column-half ">
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{ cursor: "pointer" }}
                onClick={() => setComponentType("answers")}
              >
                <div className="icon-element icon-element- mr-4 bg-1">
                  <p className="fw-bold fs-30 text-white">A</p>
                </div>
                <div className="media-body">
                  <h5 className="fw-bold fs-40 " style={{ color: "#8747ff" }}>
                    {profile?.stats?.answerCount}
                  </h5>
                  <p className="fs-15">Answers</p>
                </div>
              </div>
            </div>
            {/* end col-lg-4 */}

            <div className="responsive-column-half ">
              <div
                className="media media-card hover-bg-dark align-items-center rounded shadow"
                style={{ cursor: "pointer" }}
                onClick={() => setComponentType("connections")}
              >
                <div className="icon-element icon-element- mr-4 bg-3">
                  {/* <p className='fw-bold fs-30 text-white'>C</p> */}
                  <RocketLaunchTwoTone className="text-white fw-bold fs-30" />
                </div>
                <div className="media-body">
                  <h5 className="fw-bold fs-40 text-warning">
                    {profile?.stats?.connectionCount}
                  </h5>
                  <p className="fs-15">Connections</p>
                </div>
              </div>
            </div>
            {/* end col-lg-4 */}
          </div>
        )}

        <ProfileSubComponents />
        {/* {showResume && <ResumeMaker ComponentPdf={ComponentPdf} genratePDF= {genratePDF} />} */}
      </div>
      <GyaniRating isOpen={showGyaniModal} toggleModal={toggleGyaniModal} suggestedExperts={suggestedExperts} setSuggestedExperts={setSuggestedExperts} />
    </>
  );
}

export default UserProfile;
